import React from "react";
import Chart from "react-apexcharts";

const DealsYearChart = ({
 data = [],
 title = "Monthly Overview",
}) => {  const monthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const categories = data.map((item) => monthNames[item._id] || `Month ${item._id}`);
  const seriesData = data.map((item) => item.count);

  const options = {
    chart: {
      type: "area", 
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    colors: ["#008FFB"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 3 },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1 }
    },
    xaxis: {
      categories: categories,
      title: { text: "Month" }
    },
    yaxis: { title: { text: "Leads Count" } },
    tooltip: { x: { format: "dd/MM/yy HH:mm" } }
  };

  const series = [{ name: "Total Leads", data: seriesData }];

  return (
    
    <div id="monthly-chart">
      <h5 className="mb-3">
 {title}
</h5>
      {seriesData.some(x=>x>0) ? (
        <Chart options={options} series={series} type="area" height={300} />
      ) : (
        <div className="p-5 text-center text-muted">No monthly data available</div>
      )}
    </div>
  );
};

export default DealsYearChart;